export default __webpack_public_path__ + "static/Lense_16mm_Angle_of_View-4d45eec204660d5192359a48900ad62b.webp";